
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1441","height":"1458","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1376.15 1458c-92.19-58.66-106.56-138.42-118.12-202.51-10.7-59.36-18.28-91.61-61.26-118.81-42.98-27.2-75.36-20.26-133.58-4.51-62.83 17-141.024 39.45-231.971-19.37-90.934-57.55-105.305-137.321-116.849-201.41-10.688-59.36-18.272-91.598-61.239-118.793-43.004-27.212-75.369-20.229-133.54-3.313-62.833 15.841-141.039 37.013-231.961-20.535-90.923-57.548-105.293-136.506-116.838-201.396-10.688-59.354-18.272-91.598-61.239-118.793-42.98-27.199-75.344-20.241-133.54-4.494-62.832 17.017-141.05 38.195-231.96-19.352-90.912-57.543-105.282-137.308-116.814-201.391-10.688-59.354-17.739-91.592-61.239-118.787L-367.871 0c90.899 57.535 105.269 137.3 116.803 201.384 10.686 59.354 18.27 91.591 61.226 118.786 43.016 27.218 75.38 20.235 133.54 4.489 62.844-17.005 141.063-38.183 231.96 19.353 90.923 57.547 105.294 137.307 116.838 202.557 10.688 58.2 18.272 91.276 62.369 117.638 41.887 27.212 74.25 20.235 132.41 4.487 62.857-17.009 141.051-38.181 231.961 19.355 90.923 57.547 105.293 137.305 117.753 201.396 9.773 59.36 17.687 91.604 60.336 118.805 42.991 27.22 75.368 20.26 133.575 4.51 62.83-17.021 141.05-38.174 231.99 19.95 90.92 56.97 105.29 136.74 116.85 200.83 10.7 59.36 18.28 91.6 61.26 118.81L1376.15 1458z","fill":"#F6E94A"}})])
          )
        }
      }
    